import { auth } from '../firebase/config';
import { getIdToken } from 'firebase/auth';

// const BASE_URL = 'http://192.168.20.11:3000';
const BASE_URL = 'https://directory-api-ywsnfjdzea-as.a.run.app/';


// Helper function to get the current user's ID token
const getAuthToken = async () => {
  const currentUser = auth.currentUser;
  if (!currentUser) {
    throw new Error('User not authenticated');
  }
  return await getIdToken(currentUser, true);
};

const fetchScrapedData = async (url) => {
  try {
    // Get Firebase auth token
    const token = await getAuthToken();
    
    const response = await fetch(`${BASE_URL}/scraper/scrape`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}` // Add Firebase token to Authorization header
      },
      body: JSON.stringify({ url: url }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    if (data.success) {
      return data.data;
    } else {
      throw new Error(data.message || 'Failed to fetch data');
    }
  } catch (error) {
    console.error('Error fetching data from scraper:', error);
    throw error;
  }
};

const fetchKeywords = async (content, url = null) => {
  try {
    console.log('Extracting keywords for content:', content);
    
    // Get Firebase auth token
    const token = await getAuthToken();
    
    const response = await fetch(`${BASE_URL}/ai/extract-keywords`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}` // Add Firebase token to Authorization header
      },
      body: JSON.stringify({ content: content }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('Data:', data);
    
    let keywords = [];
    
    if (data.success) {
      // Access keywords from the nested data object
      keywords = data.data?.keywords || [];
      console.log('Keywords:', keywords);
      
      // Add domain name as a keyword if URL is provided
      if (url) {
        try {
          // Parse URL to get domain name
          const parsedUrl = new URL(url);
          const hostname = parsedUrl.hostname;
          
          // Extract domain without TLD (e.g., 'example' from 'example.com')
          let domain = hostname.split('.');
          if (domain.length >= 2) {
            domain = domain[domain.length - 2]; // Get the second-to-last part
            // Add original domain name (first letter capitalized) to keywords
            const capitalizedDomain = domain.charAt(0).toUpperCase() + domain.slice(1);
            if (capitalizedDomain.length >= 3 && !keywords.includes(capitalizedDomain)) {
              keywords.push(capitalizedDomain);
              console.log(`Added domain name "${capitalizedDomain}" to keywords`);
            }
          }
        } catch (urlError) {
          console.error('Error extracting domain from URL:', urlError);
          // Continue without adding domain if there's an error
        }
      }
    }
    
    return { keywords };
  } catch (error) {
    console.error('Error extracting keywords:', error);
    // Return empty array instead of throwing to avoid breaking the save process
    return { keywords: [] };
  }
};

export { fetchScrapedData, fetchKeywords };
